/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import InsigniaForm from './InsigniaForm';
import * as validations from '../../validations/validations';
import * as insigniaActions from '../../actions/insigniaActions';
import * as cursoActions from '../../actions/cursoActions'; 
import * as contenidoActions from '../../actions/contenidoActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import withRouter from '../common/withRouter';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';
import * as tablasActions from '../../actions/tablasActions';

import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";


import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';

class ManageInsigniaForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            headersTablaHabilidades:["Habilidades Adquiridas"],
            camposTablaHabilidades:[  "descripcion" ],
            validacionesTablaHabilidades:[],
            tipoTablaHabilidades:[ "input"],
            errors:{},
            permisos:{},
            insignia:{},
            usuario:{}
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.id;

        usuarioActual(this, "insignia",true).then( (usuario)=>{ 
            
            this.setState({usuario:usuario});
        
            this.props.contenidoActions.getArchivosDisponibles(29, usuario).then( archivos=>{
               this.setState({"archivos":archivos});
            })
            .catch(error=>{
              toastr.error(error);
            }); 


            this.props.insigniaActions.getInsigniaCombo(usuario).then( ()=>{ 

            }) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 

            this.props.cursoActions.getCursoCombo(usuario).then( ()=>{ 

            }) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 
        
        
            //this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
        
            if(id && id>0 ){

               this.props.insigniaActions.getInsignia(id, usuario).then( insignia=>{
                   this.setState({"insignia":insignia});

                   let tabla={
                        "nombre":"idsHabilidades",
                        "rows":insignia.idsHabilidades
                    };
                    this.props.tablasActions.update(tabla);

               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
            
        })
        .catch(error=>{
          toastr.error(error);
        });    
        
		
    }
    

    getTabla=(nombre)=>{
         
          let tabla=[...this.props.tablas.filter(tabla => tabla.nombre == nombre)];
        
        if(tabla.length>0){
            return tabla[0].rows;
        }
        return [];
    }
    
    
    handleChange=(event, data)=> {

        let insignia = this.state.insignia;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		insignia[field[0]]= value;
		else{
             if(!insignia[field[0]]){
                    insignia[field[0]]={}
                }
			insignia[field[0]][field[1]]= value;
		}
        
		
        this.setState({"insignia": insignia});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let insignia=this.state.insignia;
              
        if(!validations.requerido(insignia.titulo)){
            errors.titulo=true;
            formIsValid=false;
        }
       
        
        
        if(!validations.requerido(insignia.imagenInsignia)){
            errors.imagenInsignia=true;
            formIsValid=false;
        }
        
        if(!validations.requerido(insignia.descripcion)){
            errors.descripcion=true;
            formIsValid=false;
        }
        
          if(!validations.requerido(insignia.beneficios)){
            errors.beneficios=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        let idsHabilidades=this.getTabla("idsHabilidades");
        let insignia=Object.assign({}, this.state.insignia);
        insignia.idsHabilidades=idsHabilidades;
        
        this.props.insigniaActions.save(insignia, this.state.usuario).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
        });
        
    }

       
    render() {	
          
            let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 	return (
              <Segment  style={margenes}>
                <InsigniaForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.insignia}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    archivos={genericFormattedForDropdown(this.state.archivos)}
                    insigniaCombo={genericFormattedForDropdown(this.props.insigniaCombo)}
                    headersTablaHabilidades={this.state.headersTablaHabilidades}
                    camposTablaHabilidades={this.state.camposTablaHabilidades}
                    validacionesTablaHabilidades={this.state.validacionesTablaHabilidades}
                    tipoTablaHabilidades={this.state.tipoTablaHabilidades}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        tablas:state.tablas,
        user:state.user, 
        cursoCombo:state.cursoCombo,
        idioma:state.idioma,
        archivos:state.archivos,
        insigniaCombo:state.insigniaCombo, 
        form:state.form,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {  
        userActions: bindActionCreators(userActions, dispatch),
        menuActions:bindActionCreators(menuActions, dispatch),
        contenidoActions: bindActionCreators(contenidoActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        tablasActions: bindActionCreators(tablasActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        insigniaActions: bindActionCreators(insigniaActions, dispatch)
	};
}

function Parametros(){
    const {id} = useParams();
    const location = useLocation();
    return{
        id
    }
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageInsigniaForm));